import { useCallback } from "react"

import { useAppDispatch, useAppSelector } from "@/lib/hooks"
import type { RootState } from "@/lib/store"

export const useReduxState = <K extends keyof RootState>({
  key,
}: {
  key: K
}): [RootState[K], (newValue: RootState[K]) => void] => {
  const dispatch = useAppDispatch()
  const value = useAppSelector((state) => state[key])
  const setValue = useCallback(
    (newValue: RootState[K]) => {
      dispatch({ type: key, payload: newValue })
    },
    [dispatch, key],
  )
  return [value, setValue]
}
